import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-section.scss?as=stylesheet';
import {html, LitElement} from 'lit';

export class Section extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			heading: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.heading = '';
	}

	render () {
		return html`
			<section class="section">
				<h2 class="heading">${this.heading ? this.heading : html`<slot name="heading"></slot>`}</h2>
				<slot></slot>
			</section>
		`;
	}
};

defineCustomElement('x-section', Section);
